export default [
    {
        title: "Tenzies Game",  
        description: "A dice game where player rolls dice until they are all same number",
        technologies: "React,css,Javascript",
        descriptionLong: "I added extra features to the base project from the Learn React course from Scrimba. ",
        imageUrl: "../images/project.png",
        projectLink: "https://github.com/stevomusembi/Tenzies-Game-"
    },
    {
        title: "Tv show Gif Generator",
        description: "This is a webapp that fetches random gif from a Tv show and allows a caption to be added ",
        technologies:" Giphy API,React,Javascript,CSS",
        descriptionLong: "This was an idea that came about after working on a Scrimba project that generated random memes. I decided to challenge myself by making a similar web app that fetches gifs deppending on the Tv show selected, using the Giphy API, and playing them. The user can then add a caption and share it.",
        imageUrl: "../images/project3.png",
        projectLink: "http://tv-show-random-gif-generator.vercel.app/"

    }, {
        title: "Resturant Site",
        description: "This is a website for a local fastfood establishment.",
        technologies: "Wordpress, Javascript, Bootstrap",
        descriptionLong: "This project was a solution for a local business who needed a website to showcase their services in an appealing manner to increase visibility and sales. I applied skills in wordpress to provide a classy well designed solution that solved the challenge and they were very pleased with it.",
        imageUrl: "./images/project1.png",
        projectLink: "https://github.com/stevomusembi"

    }
]

//long description questons to answer
//Why did you choose to build this project?
// What challenged you when making this project?
// What did you learn from making this project?
// What learnings have you taken with you into other projects?
// What would you do differently next time?
// Did you get stuck at any point? How did you get unstuck?
// What was your process for completing this project? Did you do wireframes, make a Trello board, or did you just get stuck into it?
